// Formulaires : le snapshot Turbo part VIERGE en cache. Avec un aperçu de
// cache actif, la saisie précédente serait re-servie un instant — et un champ
// fichier n'étant jamais restaurable, une vignette restaurée promettrait une
// image que le submit n'enverrait pas. reset() retombe sur les valeurs
// d'attributs : les forms d'édition gardent le record. (Contrepartie assumée :
// back/forward ne restaure plus la saisie en cours.)
document.addEventListener('turbo:before-cache', () => {
  document.querySelectorAll('form[data-reset-on-cache]').forEach((form) => form.reset())
})
